<script setup lang="ts">
import type { CheckboxFilter } from '../../../interfaces/filters'

const filter = defineModel<CheckboxFilter>({
    required: true
})

defineProps({
    readOnly: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <label
        class="flex gap-2 text-sm items-center text-slate-900 hover:cursor-pointer"
    >
        <input v-model="filter.checked" type="checkbox" :disabled="readOnly" />
        {{ filter.name }}
    </label>
</template>
